import * as React from 'react'

import { Box, Tag, Text } from '@factorialco/deprecated-design-system'
import { capitalize } from 'lodash'

import i18n from 'modules/core/lib/i18n'

interface Props {
  type: string
}

const LeftBlock = ({ type }: Props) => {
  return (
    <Box gap="s4">
      <Text.Normal weight="medium" color="grey1000">
        {i18n.t('common.type')}
      </Text.Normal>
      <Box flexDirection="row">
        <Tag type="viridian">{capitalize(String(type))}</Tag>
      </Box>
    </Box>
  )
}

export default LeftBlock
